module.exports = __webpack_public_path__ + "img/cost-red.6ce53b73.svg";